import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.12.2@antd/es/table/index.js
// module id = 762
// module chunks = 0